export default "__VITE_ASSET__6b4babc7__"